import * as Yup from 'yup';

export const adminAddDocumentSchema = Yup.object().shape({
    description: Yup.string().required("Required"),
    fileName: Yup.string().required("Required"),
});